
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/erp-software",
      function () {
        return require("private-next-pages/erp-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/erp-software"])
      });
    }
  